import React from "react";
import clsx from "clsx";
import type { EcoConsumptionEmissionAreaType } from "../types/EcoConsumptionType";
import { IntegratedEmissionLabel } from "../../../../common-deprecated/components/emission-label/IntegratedEmissionLabel";
import styles from "./SpecEcoConsumption.module.scss";

export const EmissionEcoConsumptionArea: React.FC<EcoConsumptionEmissionAreaType> = (props) => {
    const { title, subtitle, emissionEntries } = props;
    const primaryFuel = emissionEntries[0];
    const secondaryFuel = emissionEntries[1];
    return (
        <div className={clsx(styles.wrapper, styles.emissiongraph)}>
            {title && <h4 className={styles.title}>{title}</h4>}
            {subtitle && <p className={styles.subtitle}>{subtitle}</p>}
            {emissionEntries.length && (
                <IntegratedEmissionLabel
                    value={primaryFuel?.value || ""}
                    valueLabel={primaryFuel?.label}
                    batteryValue={secondaryFuel?.value}
                    batteryValueLabel={secondaryFuel?.label}
                />
            )}
        </div>
    );
};
